function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import cn from 'classnames';
import includes from 'lodash/includes';
import { useBrowser } from 'hooks/useBrowser';
import ArrowDown from 'svg/arrow-down.svg';
import X from 'svg/x.svg';
import messages from '../../messages';
import styles from './LaunchDownloaderInstaller.pcss';
const getBrowserModifier = (browser)=>{
    if (includes([
        'Firefox',
        'Safari',
        'Chrome'
    ], browser)) {
        return browser;
    }
    return 'Other';
};
const FoldBtn = ({ isFolded, onFold })=>{
    if (isFolded) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: `modal__close ${styles.downloaderLauncher__close}`,
        children: /*#__PURE__*/ _jsx("button", {
            type: "button",
            className: "modal__close__btn",
            onClick: onFold,
            children: /*#__PURE__*/ _jsx("span", {
                className: "btn-inner",
                children: /*#__PURE__*/ _jsx(X, {
                    className: "modal__close__btn__icon"
                })
            })
        })
    });
};
const FoldableContent = ({ browserModifier, isFolded })=>{
    if (isFolded) {
        return null;
    }
    const clickPosition = browserModifier === 'Other' ? 'Below' : 'Above';
    return /*#__PURE__*/ _jsx("div", {
        className: "col",
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.downloaderLauncher__content,
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "text--h2 mb-3",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.headers[`click${clickPosition}ToInstall`]), {
                        values: {
                            clickPosition
                        }
                    }))
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: `${styles.downloaderLauncher__text} text--large text--light`,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos[`waitAndClick${clickPosition}ToInstall`]))
                })
            ]
        })
    });
};
const LaunchDownloaderInstaller = ()=>{
    const browser = useBrowser();
    if (browser === 'Server' || browser === 'EdgeChromium') {
        return null;
    }
    const browserModifier = getBrowserModifier(browser);
    const [isFolded, setIsFolded] = useState(false);
    useStyles(styles);
    const onFold = (evt)=>{
        evt.preventDefault();
        evt.stopPropagation();
        setIsFolded(true);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.downloaderLauncher, styles[`downloaderLauncher--${browserModifier}`], {
            [styles['downloaderLauncher--folded']]: isFolded
        }, 'row no-gutters align-items-center'),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: `${styles.downloaderLauncher__indicatorWrapper} col-auto`,
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.downloaderLauncher__indicator,
                    children: /*#__PURE__*/ _jsx(ArrowDown, {
                        className: cn(styles.downloaderLauncher__indicator__icon)
                    })
                })
            }),
            /*#__PURE__*/ _jsx(FoldableContent, {
                browserModifier: browserModifier,
                isFolded: isFolded
            }),
            /*#__PURE__*/ _jsx(FoldBtn, {
                isFolded: isFolded,
                onFold: onFold
            })
        ]
    });
};
export default LaunchDownloaderInstaller;
